import {
  ApolloClient,
  ApolloLink,
  createHttpLink,
  defaultDataIdFromObject,
  InMemoryCache,
  StoreObject,
} from '@apollo/client'
import { createMaintenanceCheckLink } from './createMaintenanceCheckLink'

const createCache = () => {
  const cache = new InMemoryCache({
    dataIdFromObject,
  })

  return cache
}

export const dataIdFromObject = (object: Readonly<StoreObject>) => {
  if (object.__typename && object.id) {
    return `${object.__typename}:${object.id}`
  }
  return defaultDataIdFromObject(object)
}

export const createClient = (host: string) => {
  return new ApolloClient({
    cache: createCache(),
    // NOTE: エラーを検知する link を先頭に置く必要がある
    link: ApolloLink.from([
      createMaintenanceCheckLink(),
      createHttpLink({
        uri: `${host}/id/pharmacists/graphql`,
        credentials: 'include',
      }),
    ]),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'cache-and-network',
      },
    },
  })
}
